module.exports = __webpack_public_path__ + "dist/assets/95a0220acb337d6dd7beb5b4998e2834.svg";